import userService from 'services/user-service';
import AuthManager from '../../auth/auth-manager';
import Vue from 'vue';

const defaultUser = {
  showProfile: false,
  firstName: null,
  lastName: null,
  email: null,
  phoneNumber: null,
  birthDate: null,
  address: {

  }
}

const state = {
  user: defaultUser
};

const getters = {
  showProfile: (state) => state.user.showProfile,
};

const mutations = {
  ["setShowProfile"](state, show) {
    state.user.showProfile = show;
  },
  ["get-current-user"](state, user) {
    state.user = { ...user, showProfile: state.user.showProfile };
  },
  ["update"]() {
  },
};

const actions = {
  async getCurrentUser({ commit }) {
    commit("get-current-user", await userService.getCurrent());
  },
  async update({ state, commit }) {
    await userService.update(state.user);

    commit("update");
  },

  async loginAsUser({ commit }, data) {
    localStorage.setItem("loggedInUser", localStorage.getItem("userInfo"));
    localStorage.setItem("loggedInToken", localStorage.getItem("tokenData"));

    const params = {
      reportToEditId: data.reportToEditId
    };

    if (!data.grantType)
      data.grantType = "login_as_user";

    const authManager = new AuthManager(Vue.axios, {});
    await authManager.login(data.user.email, null, false, null, data.grantType, null, null, params);

    if (data.clientRedirect || data.reportToEditId)
      window.location.replace(`${window.location.origin}/survey`);
    else
      window.location.replace(`${window.location.origin}`);

    commit("update");
  },

  async loginBackAsAdmin({ commit }) {
    const loggedInToken = localStorage.getItem("loggedInToken");
    const loggedInUser = localStorage.getItem("loggedInUser");

    localStorage.setItem("tokenData", loggedInToken);
    localStorage.setItem("userInfo", loggedInUser);

    localStorage.removeItem("loggedInToken");
    localStorage.removeItem("loggedInUser");

    window.location.replace(`${window.location.origin}/reports`);

    commit("update");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};